export default function OrderHistory() {
  return <div>Order History</div>;
}
